import React from 'react';
import PropTypes   from 'prop-types';

import * as S                from './bm-tile.module.scss';
import { ProductName }        from '../../../common/product/prod-name';
import { TagLine }            from '../../../common/product/tag-line';
import { Expiry }             from '../../../common/product/expiry';
import { setCtxNestedObj }    from '../../../../context/ctx-actions';
import { useGlobalCtx }       from '../../../../context/ctx-hook';
import { getBillManagerType } from '../../../../context/selectors/bill-selectors';
import * as ProductSelectors  from '../../../../context/selectors/product-selectors';
import * as UserSelectors     from '../../../../context/selectors/user-selectors';
import * as StateConstants    from '../../../../helpers/constants/state-constants';
import { useAutoRenew }       from '../../../../helpers/hooks/use-auto-renew';
import * as RouteHelpers      from '../../../../helpers/route-helper';
import { CancelDowngradeBox } from '../../../modals/change-plans/cancel-downgrade';
import { SingleProductRow }   from '../unified-sub-tile/product-single-row';
import RedSquareLogo          from '../../../../assets/imgs/brand/rebrand-square-logo-red.svg';
import {
  getMaxEntitlement,
  getBmTierData
} from '../../../../context/selectors/bill-selectors';
import { getQknSubscription } from '../../../../context/selectors/bill-selectors';

const TileBm = ({ product, txnId=false }) => {
  const {globalDispatch, state} = useGlobalCtx();
  // const SUB_DATA = getQknSubscription(state, state?.country);
  // const QKN_SUB = SUB_DATA?.
  // console.log(QKN_SUB);

  const BM_TYPE      = getBillManagerType(state);
  const BM_SUB       = ProductSelectors.getSubscription(state, 'billmanager');
  // const sub          = ProductSelectors.getSubscription(state, product);
  const BM_MAX_ENT = getMaxEntitlement(state);
  const BM_DATA = BM_TYPE === 'PAID' ? BM_SUB : getBmTierData(BM_MAX_ENT);

  // console.log('BM_TYPE:', BM_TYPE);
  // console.log('BM_SUB:', BM_SUB);
  // console.log('BM_MAX_ENT:', BM_MAX_ENT);
  // console.log('BM_DATA:', BM_DATA);


  return (
    <>
      {BM_TYPE == 'PAID' && BM_DATA &&
        <SingleProductRow sub={BM_DATA} testId={'BM'}/>

        // <div className={S.productRow}>
        //   <img className={S.rowLogo} alt="square product logo" src={ProductSelectors.getProductLogo(sub)}></img>
        //   <div className={S.productName}>
        //     <ProductName sub={BM_DATA} product={BM_DATA.productName} className={S.acmeName} nameStyle='inline'/>
        //     <TagLine uriName={BM_DATA.tier} className={S.tagLine} />
        //   </div>
        // </div>
      }
    </>
  );
};

TileBm.displayName  = 'TileBm';
TileBm.propTypes    = {
  product: PropTypes.string,
  txnId: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
};
TileBm.defaultProps = {
  isModal: false
};

export { TileBm };
